/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Detecting_ScenesInputs */



/**
* | output |
* | --- |
* | "Detecting scene changes..." |
*
* @param {Detecting_ScenesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const detecting_scenes = /** @type {((inputs?: Detecting_ScenesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Detecting_ScenesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Détection des changements de scène...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Szenenänderungen erkennen...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rilevamento dei cambiamenti di scena...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обнаружение изменений в сцене...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Detectando cambios de escena...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("检测场景变化……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("シーンの変化を検出しています...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("दृश्य परिवर्तन का पता लगाना...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Detectando mudanças de cena...")
	return /** @type {LocalizedString} */ ("Detecting scene changes...")
});